module.exports = __webpack_public_path__ + "static/QR-Лицензия_ЦБ_РФ_№3538_от_12_апреля_2019-e46b730f527d51223e784ee60369851e.pdf";